<template>
  <div :class="`flex flex-col justify-between items-center ${!isMobileDevice ? 'country-not-allowed-container p-n-4xl' : 'flex-1 p-n-4xl sm:p-n-2xl'}`">
    <div class="flex flex-col flex-1">
      <div class="flex justify-between">
        <div class="text-center text-n-3xl font-bold mx-auto md:text-n-xl">
          {{$t('closed_beta')}}
        </div>
      </div>
    
      <div class="text-container mt-n-4xl text-n-xl xl:mt-n-4xl md:text-n-md">
        {{$t('authentication.country_not_allowed')}}
      </div>

      <HCaptcha
        ref="hCaptchaRef"
        @onChallengeExpired="onClose"
        @onClosed="onClose"
        @onError="onError"
        @onExpired="onClose"
        @onVerify="onVerify"
      />

      <div class="flex flex-col mt-auto">
        <ButtonV2
          @onClick="joinWaitlist"
          :inactive="isLoading"
          testId="btn-join-waitlist"
          :label="$t('invites.join_the_waitlist')"
          class="mt-n-5xl"
          wide
        />
      </div>
    </div>
  </div>
</template>

<script>
import LANDING_PAGE_SIGNUP from '@/graphql/mutations/LandingPageSignUp.gql';
import ButtonV2 from '@/stories/misc/ButtonV2';
import HCaptcha from '@/components/misc/HCaptcha';

import { isApiError } from '@/utils/error-handler';

  export default {
    name: 'CountryNotAllowed',

    components: {
      ButtonV2,
      HCaptcha,
    },

    props: {
      email: {
        type: String,
        required: true,
      }
    },

    data() {
      return { 
        captcha: '',
        isLoading: false,
      };
    },

    methods: {
      async joinWaitlist() {
        this.isLoading = true;
        try {
          await this.$apollo.mutate({
            mutation: LANDING_PAGE_SIGNUP,
            variables: {
              email: this.email,
              captcha: this.captcha,
              ref: this.$route.query.ref,
            }
          });
          
          this.showSuccess(this.$t('success.joined_waitlist'));
          this.hideModal();
        } catch (err) {
          if (isApiError(err)) {
            if (err['error_code'] === 'invalid_captcha') {
              return this.onSubmit();
            }
          }

          this.isLoading = false;
          await this.showError(err);
        }
      },

      onClose() {
        this.isLoading = false;
      },

      onError() {
        this.isLoading = false;
      },

      onSubmit() {
        this.$refs.hCaptchaRef.execute();
      },

      async onVerify(captcha) {
        this.captcha = captcha;
        await this.joinWaitlist();
      },
    },
  };
</script>

<style scoped>
.country-not-allowed-container {
  width: 450px;
}
.text-container {
  @apply flex justify-between items-center text-text-body font-semibold;
}
</style>
